import { render, staticRenderFns } from "./index.vue?vue&type=template&id=54ef9008&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=54ef9008&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ef9008",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/drone/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54ef9008')) {
      api.createRecord('54ef9008', component.options)
    } else {
      api.reload('54ef9008', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=54ef9008&scoped=true", function () {
      api.rerender('54ef9008', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/BrokerCard/index.vue"
export default component.exports